import React from 'react';
import Modal, { ModalBody, ModalFooter } from '../bootstrap/Modal';
import Button from '../bootstrap/Button';

const ConfirmModal = ({
	isOpen,
	setIsOpen,
	title,
	description,
	cancelText = '아니요',
	confirmText = '네, 삭제할게요',
	onCancel,
	onConfirm,
	hideCancel = false,
	children,
}) => {
	return (
		<Modal isCentered modalClassNameProps='complete_modal' isOpen={isOpen} setIsOpen={setIsOpen}>
			<ModalBody>
				<div className='m-3'>
					<div className='fs-4 fw-bold d-flex justify-content-center mb-2'>{title}</div>
					{description && (
						<div className='d-flex justify-content-center mb-1 text-muted'>{description}</div>
					)}
					{children}
				</div>
			</ModalBody>
			<ModalFooter style={{ justifyContent: 'unset', gap: 0 }}>
				{!hideCancel && (
					<div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', paddingRight: '6px' }}>
						<Button
							style={{ border: '1px solid #D9D9D9', borderRadius: 7, color: '#808080' }}
							onClick={onCancel}
						>
							{cancelText}
						</Button>
					</div>
				)}
				<div style={{ flex: hideCancel ? 'unset' : 1, display: 'flex', justifyContent: hideCancel ? 'center' : 'flex-start', paddingLeft: hideCancel ? 0 : '6px' }}>
					<Button
						className='btn_confirm'
						style={{ borderRadius: 7 }}
						onClick={onConfirm}
					>
						{confirmText}
					</Button>
				</div>
			</ModalFooter>
		</Modal>
	);
};

export default ConfirmModal;
